import { render } from "./WebWidget.vue?vue&type=template&id=5c673b12&ts=true"
import script from "./WebWidget.vue?vue&type=script&lang=ts"
export * from "./WebWidget.vue?vue&type=script&lang=ts"

import "./WebWidget.vue?vue&type=style&index=0&id=5c673b12&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__